import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=01becac9&"
import script from "./CancelButton.vue?vue&type=script&lang=ts&"
export * from "./CancelButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports